import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotSection from './components/HotSection';
import CategorySection from './components/CategorySection';
import UpdateSection from './components/UpdateSection';
import RankingSection from './components/RankingSection';
import { Helmet } from './components/SEOHelmet';

export default function Home() {
  return (
    <>
      <Helmet
        title="妖精动漫网 - 妖精动漫官网入口 | 免费韩漫日漫国漫在线阅读平台"
        description="妖精动漫网官网入口，提供妖精动漫平台最新网站地址，免费在线看韩漫、日漫、国漫全集，支持下拉式阅读，追更收藏一站搞定。海量高清漫画资源，每日更新。"
        keywords="妖精动漫网,妖精动漫官网,妖精动漫入口,妖精动漫平台,妖精动漫网站,妖精动漫免费,妖精动漫在线阅读,妖精动漫韩漫,妖精动漫日漫,妖精动漫国漫"
        canonical="https://www.yaojingdongman.com"
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <HeroSection />
          <HotSection />
          <CategorySection />
          <UpdateSection />
          <RankingSection />

          {/* CTA Banner */}
          <section className="py-16 md:py-20">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="relative rounded-2xl overflow-hidden bg-gradient-to-r from-primary-600 to-accent-600 p-10 md:p-16 text-center">
                  <div className="absolute inset-0 opacity-10">
                    <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-background-50" />
                    <div className="absolute -bottom-8 -left-8 w-32 h-32 rounded-full bg-background-50" />
                  </div>
                  <div className="relative z-10">
                    <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
                      开启你的漫画之旅
                    </h2>
                    <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8">
                      海量韩漫、日漫、国漫高清资源，每日更新，下拉式沉浸阅读体验，随时随地畅享漫画世界。
                    </p>
                    <a
                      href="/category/hanman"
                      className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 hover:bg-background-100 text-primary-700 text-sm font-semibold rounded-lg transition-colors whitespace-nowrap"
                    >
                      <i className="ri-compass-3-line text-lg"></i>
                      立即探索
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>

      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": "https://www.yaojingdongman.com/#organization",
                "name": "妖精动漫",
                "url": "https://www.yaojingdongman.com",
                "description": "妖精动漫网官网入口，提供妖精动漫平台最新网站地址，免费在线看韩漫、日漫、国漫全集",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.yaojingdongman.com/logo.png"
                },
                "contactPoint": {
                  "@type": "ContactPoint",
                  "email": "contact@yaojingdongman.com",
                  "contactType": "customer service"
                }
              },
              {
                "@type": "WebSite",
                "@id": "https://www.yaojingdongman.com/#website",
                "url": "https://www.yaojingdongman.com",
                "name": "妖精动漫",
                "inLanguage": "zh-CN",
                "publisher": { "@id": "https://www.yaojingdongman.com/#organization" }
              },
              {
                "@type": "WebPage",
                "@id": "https://www.yaojingdongman.com/#webpage",
                "url": "https://www.yaojingdongman.com",
                "name": "妖精动漫网 - 免费在线漫画阅读平台",
                "description": "妖精动漫网官网入口，提供妖精动漫平台最新网站地址，免费在线看韩漫、日漫、国漫全集",
                "inLanguage": "zh-CN",
                "isPartOf": { "@id": "https://www.yaojingdongman.com/#website" },
                "about": { "@id": "https://www.yaojingdongman.com/#organization" }
              }
            ]
          })
        }}
      />
    </>
  );
}